import { Navigate, Outlet, useParams } from 'react-router-dom'

export function FollowupIdGuard() {
  const { followupId, locale, projectId } = useParams()

  if (!followupId || Number.isNaN(Number(followupId))) {
    return <Navigate to={`/${locale}/${projectId}/configuration/followups`} replace />
  }

  return <Outlet />
}
